export function Lifegatechurchweb1 ()
{


return(



    <>
    
    
    <div>hiii</div>
    
    </>
)



}